import { useEffect, useState } from "react";
import { getAllRibbonBadges } from "../services/api";

export default function useBadges() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getAllRibbonBadges().then((data) => {
      setCategories(data);
    });
  }, []);

  return categories;
}
